import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const labels = ["גן חובה", "א", "ב", "ג"]

const BarChart = (props) => {
    const { showGoResult } = props

    const datasets = useMemo(
        () => [
            showGoResult && {
                data: [30, 30, 60, 42],
                backgroundColor: [
                    '#E1E1E1',
                    '#E1E1E1',
                    '#E1E1E1',
                    '#E1E1E1'
                ],
                borderWidth: 0,
            },
            showGoResult && {
                // label: 'Sales1',
                data: [50, 40, 70, 48],
                backgroundColor: [
                    '#A1A1A1',
                    '#A1A1A1',
                    '#A1A1A1',
                    '#A1A1A1'
                ],
                borderWidth: 0,
            },
            {
                // label: 'Sales2',
                data: [70, 40, 100, 48],
                backgroundColor: [
                    "#91BDFA",
                    "#91BDFA",
                    "#91BDFA",
                    "#91BDFA",
                ],
                borderWidth: 0,
            },
            {
                // label: 'Sales3',
                data: [100, 120, 145, 70],
                backgroundColor: [
                    "#FB7401",
                    "#FB7401",
                    "#FB7401",
                    "#FB7401"
                ],
                borderWidth: 0
            }
        ], [showGoResult]
    )

    const data = {
        labels: labels,
        datasets: datasets
    };

    const options = {
        responsive: true,
        scales: {
            y: {
                ticks: {
                    stepSize: 10, // Adjust step size to ensure all values are visible
                },
            },
            x: {
                grid: {
                    display: false, // Hides the y-axis grid lines
                },
            }
        },
        plugins: {
            datalabels: {
                display: false, // Hide labels for this Bar component
            },
            legend: {
                display: false
            },
            title: {
                display: false,
            },
        },
    };

    return <Bar key={"bar-chart"} data={data} options={options} />;
};

export default BarChart;